import { useQuery } from '@tanstack/react-query';
import { getDashboardSummaryOptions } from '@/shared/api/generated/@tanstack/react-query.gen';
import type { GetDashboardSummaryData } from '@/shared/api/generated/types.gen';

export const dashboardQueries = {
  summary: (params?: GetDashboardSummaryData) =>
    getDashboardSummaryOptions(params),
};

export const useDashboardSummary = (
  params?: GetDashboardSummaryData,
  enabled: boolean = true
) => {
  return useQuery({
    ...dashboardQueries.summary(params),
    enabled,
  });
};
